
import Vue, { PropType } from 'vue'

import { IProduct } from 'types/DTO/products'
import { IBreadCrumbs } from 'types/DTO/breadCrumbs'
import { ICategory } from 'types/DTO/categories'
import RPHProductSpecsContainer from 'rph/templates/RPHProductSpecsContainer/index.vue'
import RPHReviewBlock from 'rph/organisms/RPHReviewBlock/index.vue'
import { IEntityReviewProps } from 'types/DTO/reviews'

export default Vue.extend({
  name: 'RPHProductMain',
  components: {
    RPHReviewBlock,
    RPHProductSpecsContainer,
    Heading: () => import('~/components/atoms/Heading.vue'),
    Breadcrumbs: () => import('~/components/moleculus/Breadcrumbs.vue'),
    RPHTabsList: () => import('rph/organisms/RPHTabsList/index.vue'),
    RPHProductDetails: () => import('rph/organisms/RPHProductDetails/index.vue'),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    product: {
      type: Object as PropType<IProduct>,
    },
  },

  data() {
    return {
      changePriceModalText: {
        mainText: 'Вы покупаете товар со скидкой',
        yellowText: '',
        btnConfirmText: 'Да',
      },
      isHeaderHide: false,
    }
  },
  computed: {
    breadCrumbs(): IBreadCrumbs[] {
      const title = this.product.title
      const slug = this.product.slug
      const tradeName = this.product.trade_name.title
      const tradeNameId = this.product.trade_name.slug
      return this.$services.breadcrumbs.createCrumbs([
        // @ts-ignore
        ...this.categoryBySlug?.parents,
        { title: this.categoryBySlug?.title, slug: this.categoryBySlug?.slug },
        { title: tradeName, slug: `preparaty/${tradeNameId}` },
        { title, slug },
      ])
    },
    analogsCount(): Number {
      return this.product.analogues ? +this.product.analogues[0]?.product_count : 0
    },
    reviewsCount(): Number {
      return this.$store.getters['rph-reviews/reviewsCount']
    },
    hasRecommendedProducts(): boolean {
      return this.$store.getters['rph-products/recommendedProducts'].length > 0
    },
    categoryBySlug(): ICategory {
      return this.$store.getters['rph-categories/categoryBySlug']
    },
    isHeaderShown(): boolean {
      return this.$store.getters['rph-menu/isHeaderShown']
    },

    isProductPage() {
      return this.$route.name === 'product-slug'
    },

    entityReview(): IEntityReviewProps {
      return {
        id: Number(this.product.id),
        type: 'product',
        short_title: this.product?.short_title,
        title: this.product?.short_title + ' ' + this.product?.specification?.issue_form,
        heading: 'Отзывы о товаре',
        placeholder: 'Опишите товар',
      }
    },
  },

  mounted() {
    window.addEventListener('scroll', this.onScrollHandler.bind(this))
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScrollHandler.bind(this))
  },

  methods: {
    onScrollHandler() {
      const st = window.scrollY
      const headerHideOffset = 50
      this.isHeaderHide = st > headerHideOffset
    },
  },
})
